import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Guide from "@/pages/Guide";
import Login from "@/pages/Login";
import Verify from "@/pages/Verify";
import ReferralCapture from "@/pages/ReferralCapture";
import WeddingsHub from "@/pages/WeddingsHub";
import VenuePage from "@/pages/VenuePage";
import Admin from "@/pages/Admin";
import Poster from "@/pages/Poster";

const IS_WEDDINGS_HOST = window.location.hostname.startsWith("weddings.");

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothTouch: false });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={IS_WEDDINGS_HOST ? <VenuePage fixedSlug="pebble-farms" /> : <Landing />} />
          <Route path="/stay" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/weddings" element={<WeddingsHub />} />
          <Route path="/weddings/:slug" element={<VenuePage />} />
          <Route path="/:code" element={<ReferralCapture />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/poster" element={<Poster />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
